import { BasePreloadingStore } from './BasePreloadingStore';

export class IgnorePreloadingStore extends BasePreloadingStore {
  constructor() {
    super();
    this.preloaded();
  }
}
